import { FunctionComponent, Suspense, memo, useEffect } from 'react'
import { Pages, PagesEnum } from '../content/pages/pages'
import { navigationService } from '../content/services/navigation.service'
import { PageLoading } from '../content/pages/helpers/PageLoading'
import { scrollToHashElement } from '../content/utilities/jumpLinks'

export const PageWrapper: FunctionComponent<{ page: PagesEnum; overrideElement?: FunctionComponent }> = memo(props => {
    useEffect(() => {
        navigationService.setCurrentPage(props.page)

        scrollToHashElement()
    })

    const PageElement = props?.overrideElement ?? Pages[props.page].component

    return (
        <Suspense fallback={<PageLoading />}>
            <PageElement />
        </Suspense>
    )
})
